import React from 'react';
import CellContent from '../../../../common/CellContent/CellContent';
import { texts } from '../../../../../constants/texts';
import AppBlock from '../../../../common/AppBlock/AppBlock';
import { ReactComponent as NotMobileIcon } from '../../../../../../../resource/NotMobileIcon.svg';
import { ReactComponent as MobileIcon } from '../../../../../../../resource/MobileIcon.svg';
import { columnKeyMap } from '../../constants/columnKeyMap';
import {
  TableFilterDropdown,
  TableFilterIcon,
} from '../../../../../../../components/tableComponents';
import ActionsCell from '../../../../common/ActionsCell/ActionsCell';
import PhoneNumber from '../../../../../../../components/PhoneNumber/PhoneNumber';
import styles from '../TenantsTable.module.scss';
import moment from 'moment';
import { Tooltip } from 'antd';
import VerifiedBlock from '../../../../common/VerifiedBlock/VerifiedBlock';

const { alive, tenantMark, name, address, fio, verificationDate, isVerified } =
  columnKeyMap;

const aliveCellWidth = '64px';

const widths = {
  mark: 0.07,
  nickname: 0.14,
  fio: 0.2,
  contacts: 0.15,
  company: 0.15,
  address: 0.2,
  account: 0.06,
  actions: 0.06,
  isVerified: 0.02,
  verificationDate: 0.04,
};

const aliveFilterText = (text, icon) => (
  <span
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}
  >
    {icon}
    <span style={{ marginLeft: '8px' }}>{text}</span>
  </span>
);

export const getTenantsTableColumns = ({
  companyName,
  sortedInfo,
  filteredInfo,
  handlers = {},
  houseOptions,
}) => [
  {
    dataIndex: alive,
    key: alive,
    colSpan: 1,
    width: aliveCellWidth,
    filters: [
      {
        text: aliveFilterText('С мобильным приложением', <MobileIcon />),
        value: true,
      },
      {
        text: aliveFilterText('Без мобильного приложения', <NotMobileIcon />),
        value: false,
      },
    ],
    filteredValue:
      filteredInfo && filteredInfo[alive] ? filteredInfo[alive] : null,
    filterIcon: (filtered) => <TableFilterIcon filtered={filtered} />,
    filterDropdown: (props) => (
      <TableFilterDropdown
        {...props}
        filterMultiple={false}
      />
    ),
    render: (alive) => (
      <AppBlock
        hasApp={alive}
        rootClassName={styles.hasAppBlock}
      />
    ),
  },
  {
    title: 'Признак',
    dataIndex: 'isOwner',
    key: tenantMark,
    colSpan: 1,
    width: `calc((100% - ${aliveCellWidth}) * ${widths.mark})`,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === tenantMark && sortedInfo?.order,
    filters: [
      { text: 'Собственник', value: true },
      { text: 'Житель', value: false },
    ],
    filteredValue:
      filteredInfo && filteredInfo[tenantMark]
        ? filteredInfo[tenantMark]
        : null,
    filterIcon: (filtered) => <TableFilterIcon filtered={filtered} />,
    filterDropdown: (props) => (
      <TableFilterDropdown
        {...props}
        filterMultiple={false}
      />
    ),
    render: (isOwner) => (
      <CellContent
        topRowContent={isOwner ? texts.owner : texts.tenant}
        isHighlighted
      />
    ),
  },
  {
    title: 'Псевдоним',
    dataIndex: name,
    key: name,
    width: `calc((100% - ${aliveCellWidth}) * ${widths.name})`,
    colSpan: 1,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === name && sortedInfo?.order,
    render: (name) => (
      <CellContent
        style={{ maxWidth: '310px' }}
        topRowContent={name}
        isHighlighted={Boolean(name)}
      />
    ),
  },
  {
    title: 'ФИО',
    dataIndex: fio,
    key: fio,
    width: `calc((100% - ${aliveCellWidth}) * ${widths.fio})`,
    colSpan: 1,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === fio && sortedInfo?.order,
    render: (fio) => (
      <CellContent
        style={{ maxWidth: '310px' }}
        topRowContent={fio}
        isHighlighted={Boolean(fio)}
      />
    ),
  },
  {
    title: 'Контакты',
    key: 'contacts',
    colSpan: 1,
    width: `calc((100% - ${aliveCellWidth}) * ${widths.contacts})`,
    render: (record) => (
      <CellContent
        topRowContent={
          record.phone ? (
            <PhoneNumber
              phoneNumber={record.phone}
              name={record.name}
            />
          ) : (
            ''
          )
        }
        bottomRowContent={record.email}
      />
    ),
  },
  {
    title: 'Управляющая компания',
    key: 'company',
    colSpan: 1,
    width: `calc((100% - ${aliveCellWidth}) * ${widths.company})`,
    render: () => <CellContent topRowContent={companyName} />,
  },
  {
    title: 'Адрес',
    key: address,
    dataIndex: address,
    colSpan: 1,
    width: `calc((100% - ${aliveCellWidth}) * ${widths.address})`,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === address && sortedInfo?.order,
    filters: houseOptions,
    filteredValue:
      filteredInfo && filteredInfo[address] ? filteredInfo[address] : null,
    filterIcon: (filtered) => <TableFilterIcon filtered={filtered} />,
    filterDropdown: (props) => (
      <TableFilterDropdown
        {...props}
        filterMultiple
      />
    ),
    render: (address) => <CellContent topRowContent={address} />,
  },
  {
    title: (
      <Tooltip title="Признак подтверждения паспортных данных">
        <span>Признак</span>
      </Tooltip>
    ),
    key: isVerified,
    dataIndex: isVerified,
    colSpan: 1,
    width: `calc((100% - ${aliveCellWidth}) * ${widths.isVerified})`,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === isVerified && sortedInfo?.order,
    filters: [
      { text: 'Подтвержден', value: true },
      { text: 'Не подтвержден', value: false },
    ],
    filteredValue:
      filteredInfo && filteredInfo[isVerified]
        ? filteredInfo[isVerified]
        : null,
    filterIcon: (filtered) => <TableFilterIcon filtered={filtered} />,
    filterDropdown: (props) => (
      <TableFilterDropdown
        {...props}
        filterMultiple
      />
    ),
    render: (isVerified) => {
      if (isVerified === null || isVerified === undefined) return null;

      return (
        <VerifiedBlock
          isVerified={isVerified}
          rootClassName={styles.hasAppBlock}
        />
      );
    },
  },
  {
    title: (
      <Tooltip title="Дата проверки паспортных данных">
        <span>Дата проверки</span>
      </Tooltip>
    ),
    key: verificationDate,
    dataIndex: verificationDate,
    colSpan: 1,
    width: `calc((100% - ${aliveCellWidth}) * ${widths.verificationDate})`,
    sorter: true,
    sortOrder: sortedInfo?.columnKey === verificationDate && sortedInfo?.order,
    render: (verificationDate) => (
      <CellContent
        topRowContent={
          !!verificationDate
            ? moment(verificationDate).format('DD.MM.YYYY')
            : null
        }
        isHighlighted={!!verificationDate}
      />
    ),
  },
  {
    key: 'accountCount',
    colSpan: 1,
    width: `calc((100% - ${aliveCellWidth}) * ${widths.account})`,
  },
  {
    key: 'requestCount',
    colSpan: 1,
    width: `calc((100% - ${aliveCellWidth}) * ${widths.actions})`,
    render: (_data, record) => (
      <ActionsCell
        record={record}
        onDeleteBtnClick={handlers.onDeleteBtnClick}
        onEditBtnClick={handlers.onEditBtnClick}
      />
    ),
  },
];
